const toastEl = document.getElementById("toast");
let toastTimer = null;
const TOAST_ICONS = {
  success:
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>',
  error:
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="7" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>',
};
const TOAST_BACKGROUNDS = { success: "#047857", error: "#be123c" };

export function showToast(message: string, kind: "success" | "error") {
  toastEl.innerHTML = TOAST_ICONS[kind] || "";
  toastEl.style.background = TOAST_BACKGROUNDS[kind] || "#0f172a";
  toastEl.insertAdjacentText("beforeend", message);
  toastEl.style.opacity = "1";
  toastEl.style.transform = "translateX(-50%) translateY(0)";
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    toastEl.style.opacity = "0";
    toastEl.style.transform = "translateX(-50%) translateY(20px)";
  }, 2800);
}
